import CommonFileUpload from "../../../../_utils/CommonFileUpload";

const BulkTransactionStepUpload = ({ files, setFiles }) => {
  return (
    <div className="max-w-tab-width-normal mx-auto flex flex-col Qlg:flex-row Qlg:gap-gap-xl gap-gap-md">
      <div className="relative rounded-border-radius-md w-width-full bg-primary-card Qlg:max-w-[--create-box-width] h-[fit-content]">
        <div className="bg-primary-card p-padding-md rounded-border-radius-md">
          <div className="flex flex-col gap-gap-sm">
            <div className="flex flex-col gap-gap-sm text-text-primary">
              <p className="font-semibold text-font-md">Sample File</p>
              <div className="flex flex-col gap-gap-sm">
                <p className="text-font-xs font-normal">Note:</p>
                <ul className="text-font-xs font-normal list-disc pl-padding-md">
                  <li>
                    For a successful transaction upload:
                    <ul className="list-none pl-padding-xs">
                      <li>
                        - Make sure to use the sample file which will be
                        provided by Xpentra’s support team.
                      </li>
                      <li>
                        - Debit account must exist on Xpentra, do not enter new
                        ones.
                      </li>
                    </ul>
                  </li>
                  <li>
                    New beneficiary accounts identified in the uploaded file
                    will be created and added to the pending accounts.
                  </li>
                  <li>
                    Make sure to export the sample file into <b>.csv</b> format
                    only.
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex justify-end text-font-xs font-normal text-text-primary">
              {/* <PrimaryWithIconButton
                btnText="Sample file"
                btnType="button"
                icon={ICONS?.DOWNLOAD_STATEMENT}
                iconToBeAlign="left"
                hoverOption="black"
                fullWidthRequired={false}
                inActiveVariantNeeded={false}
                enabledTextColor="var(--text-primary)"
                disabledTextColor="var(--text-primary)"
                enabledBgColor="var(--emphasis)"
                disabledBgColor="var(--emphasis)"
                isDisabled={
                  !selectedCategory?.id ||
                  !ensureAll(["VTransactionUpload"]).status
                }
                handleFunction={() => {
                  const serviceCheck = ensureAll(["VTransactionUpload"]);
                  if (serviceCheck.status) {
                    if (selectedCategory?.id) handleDownloadSample();
                  } else {
                    navigate("/feature_not_assigned", {
                      state: serviceCheck.unavailableService,
                    });
                  }
                }}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="h-auto media-password w-width-md bg-primary-card rounded-border-radius-md mb-margin-md Qlg:mb-margin-base p-padding-md">
        <p className="font-sans font-semibold text-font-md text-text-primary">
          Upload File
        </p>
        <div className="mt-margin-md">
          <CommonFileUpload
            files={files}
            setFiles={setFiles}
            type="custom"
            customExtensions={[".csv"]}
          />
        </div>

        <div className="flex flex-col gap-gap-sm mt-margin-md text-text-primary">
          <span className="font-sans font-normal text-font-xs">
            File verification process post upload:
          </span>
          <ul className="text-font-xs font-normal list-disc pl-padding-md">
            <li>
              Our system validates the values in each row. If any errors are
              identified, the entire file will get rejected.
            </li>
            <li>
              Upon successful validation, you will be notified by email, and the
              corresponding transactions will be created and sent for approval.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BulkTransactionStepUpload;
